<div class="subscribe-content">
    <h4>SUBSCRIBE FOR ADMISSION INFORMATION</h4>
    <form class="newsletter-form">
        <input type="text" class="input-newsletter" placeholder="Enter your email address" name="EMAIL" required
               autocomplete="off">
        <button type="submit" class="default-btn" style="background-color: #27166d;"><i class="flaticon-user"></i>Subscribe
            Now<span></span></button>
    </form>
</div>
